import { Draggable, Droppable } from "react-beautiful-dnd";
import { EllipsisTooltipText } from "../../../common/components/EllipsisTextWithTooltip";

export const HeaderDraggableLine = ({ rows, deleteItem, handleChangeInput, droppedItems = [], isReadOnly = false }) => {
    return rows.map((rowCards, rowIndex) => (
        <Droppable key={`droppable-${rowIndex}`} droppableId={`droppable-${rowIndex}`} direction="horizontal" type="item" isDropDisabled={isReadOnly}>
            {(provided, snapshot) => (
                <ul className={`listing ${rowIndex !== 0 ? "pt-0" : ""} mt-0`} {...provided.droppableProps} ref={provided.innerRef}>
                    {rowCards.length > 0 ? (
                        rowCards.map((item, i) => (
                            <Draggable key={item.id} draggableId={String(item.id)} index={i} isDragDisabled={isReadOnly}>
                                {(provided, snapshot) => (
                                    <li
                                        className={`outer-flex-item d-flex mt-0 mb-0 ${snapshot.isDragging ? "dragging" : ""}`}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={{
                                            userSelect: "none",
                                            listStyle: "none",
                                            paddingBottom: 0,
                                            ...provided.draggableProps.style
                                        }}
                                    >
                                        <div className="inner-box">
                                            {item.isText ? (
                                                <div className="item-txt">
                                                    <input
                                                        className="not-draggable"
                                                        type="text"
                                                        value={item.value}
                                                        onChange={e => handleChangeInput(e, rowIndex, i)}
                                                        placeholder="Enter text"
                                                        disabled={isReadOnly}
                                                    />
                                                    {!isReadOnly && (
                                                        <button
                                                            className="not-draggable close-btn-icn"
                                                            onClick={() => deleteItem(rowIndex, i)}
                                                            disabled={isReadOnly}
                                                        >
                                                            <img src="/img/close.svg" />
                                                        </button>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="item-txt">
                                                    <EllipsisTooltipText text={item?.content} className={"overflow-text-wrapper"} />
                                                    {!isReadOnly && (
                                                        <button
                                                            className="not-draggable close-btn-icn"
                                                            onClick={() => deleteItem(rowIndex, i)}
                                                            disabled={isReadOnly}
                                                        >
                                                            <img src="/img/close.svg" />
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </li>
                                )}
                            </Draggable>
                        ))
                    ) : droppedItems?.length === 0 ? (
                        <li className="item upload">
                            <div className="upload-sec">
                                {isReadOnly ? (
                                    <h3>No Data</h3>
                                ) : (
                                    <>
                                        <img src="/img/drag-drop.svg" alt="" />
                                        <h3>Drop Items Here</h3>
                                    </>
                                )}
                            </div>
                        </li>
                    ) : (
                        <li></li>
                    )}
                    {provided.placeholder}
                </ul>
            )}
        </Droppable>
    ));
};
